import { render, staticRenderFns } from "./TargetedUserLists.vue?vue&type=template&id=f3722098&"
import script from "./TargetedUserLists.vue?vue&type=script&lang=js&"
export * from "./TargetedUserLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports